import { useState } from 'react';
import { Ui } from '@silvertours/front-shared';
import {
  Anchor,
  GradientBackground,
  StyledImage,
  StyledImageWithFocalPoint,
  Subtitle,
} from '../LinkGrid.styles';
import { GridImageLinkProps } from '../../types';

export const GridImageLink = ({
  content: { href, image, label },
  rules: { color, layout, hidden },
}: GridImageLinkProps) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Anchor
      bgColor={color}
      layout={layout}
      href={href}
      hidden={!!hidden}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {image?.src && image.focalPoint && (
        <StyledImageWithFocalPoint {...image} />
      )}
      {image?.src && !image.focalPoint && (
        <StyledImage
          {...image}
          fill
          width={undefined}
          height={undefined}
          unoptimized={Ui.needsUnoptimizedImage(image.src)}
        />
      )}
      <GradientBackground isHovered={isHovered}>
        <Subtitle as="h3" textColor="white">
          {label}
        </Subtitle>
      </GradientBackground>
    </Anchor>
  );
};
